<div
  class="widget-card"
  [id]="'widget-' + widget.id"
  [ngClass]="{
    preview: widgetPreview,
    'section-break': widgetTypeId == WidgetType.WIDGET_TYPE_SECTION_BREAK,
    selected: objectActionService?.isObjectSelected(widget),
  }"
  [class.widget-placeholder]="
    widgetTypeId == WidgetType.WIDGET_TYPE_PLACEHOLDER
  "
  [style.--widget-header-bg]="
    widgetTypeId !== WidgetType.WIDGET_TYPE_PLACEHOLDER
      ? widget.settings?.widget_header_color
      : null
  "
  [style.--widget-header-fg]="
    widgetTypeId !== WidgetType.WIDGET_TYPE_PLACEHOLDER ? headerTextColor : null
  "
  [class.widget-placeholder-selected]="isPlaceholderSelected"
  (click)="
    widgetTypeId == WidgetType.WIDGET_TYPE_PLACEHOLDER
      ? selectWidgetPlaceholder()
      : null
  "
>
  <div class="card-header widget-drag-handle">
    <div
      class="card-info"
      (click)="canEditWidget ? toggleWidgetSelect() : null"
    >
      <ng-container *ngIf="canEditWidget; else noEdit">
        <div class="select-tool" *ngIf="editMode; else spacer">
          <sui-checkbox
            [checked]="(isSelected$ | async) ?? false"
          ></sui-checkbox>
        </div>
      </ng-container>

      <ng-template #noEdit>
        <div class="select-tool select-tool--spacer"></div>
      </ng-template>

      <ng-template #spacer>
        <div class="select-tool select-tool--spacer"></div>
      </ng-template>

      <div
        class="card-title"
        [innerHTML]="widget.title | highlight: searchString"
      ></div>
    </div>
    <div class="card-tools" *ngIf="editMode">
      <ng-container
        *ngIf="
          widget.widget_type_id !== WidgetType.WIDGET_TYPE_PLACEHOLDER &&
          widget.widget_type_id !== WidgetType.WIDGET_TYPE_SECTION_BREAK
        "
      >
        <div class="card-tool">
          <sui-button
            size="sm"
            variant="ghost"
            [leadingIcon]="['fas', 'bars']"
            [trailingIcon]="['fas', 'caret-down']"
            [iconOnly]="true"
            ariaLabel="Widget menu"
            [expanded]="widgetMenuRef.isOpen()"
            [suiMenuTrigger]="widgetMenu"
            #widgetMenuRef="suiMenu"
          ></sui-button>
          <ng-template #widgetMenu>
            <sui-menu>
              <ng-container *ngFor="let item of dropdownItems">
                <!-- Separator -->
                <sui-menu-separator
                  *ngIf="item.isSeparator"
                ></sui-menu-separator>

                <!-- Header -->
                <sui-menu-header *ngIf="item.isTitle">
                  <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
                  <span>{{ item.name }}</span>
                </sui-menu-header>

                <!-- Regular Item -->
                <button
                  sui-menu-item
                  (click)="onItemClick(item)"
                  *ngIf="!item.isSeparator && !item.isTitle"
                >
                  <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
                  <span>{{ item?.name }}</span>
                </button>
              </ng-container>
            </sui-menu>
          </ng-template>
        </div>
      </ng-container>
      <div
        class="card-tool"
        *ngIf="
          widgetTypeId !== WidgetType.WIDGET_TYPE_PLACEHOLDER && canEditWidget
        "
      >
        <app-color-picker
          [size]="20"
          [ngModel]="widget.settings.widget_header_color"
          (ngModelChange)="updateWidgetHeaderColor($event)"
        ></app-color-picker>
      </div>
      <ng-container *ngFor="let tool of cardTools">
        <div class="card-tool" (click)="tool.action()">
          <a suiTooltip="{{ tool.tooltip }}">
            <fa-icon [icon]="tool.icon"></fa-icon>
          </a>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="filter-bar" *ngIf="editMode && !widgetPreview && widget.id">
    <div class="filter-items" *ngIf="supportsDataSources">
      <ng-container *ngIf="showDataSources$ | async">
        <ng-container *ngIf="hasDatasources$ | async; else noDatasources">
          <span> {{ "widget-card.label.datasources" | translate }}: </span>
          <span
            class="datasource"
            *ngFor="let datasource of datasources$ | async"
            (click)="configureDatasourceObject(datasource)"
            [style.backgroundColor]="datasource.color ? datasource.color : null"
          >
            <fa-icon [icon]="datasource.icon"></fa-icon>
            {{ datasource.title }}
          </span>
        </ng-container>
        <ng-template #noDatasources>
          <span class="no-datasources"
            >{{ "widget-card.label.no-datasources-available" | translate }}.
            <a (click)="configureDatasource()" class="filter-tool"
              >{{ "widget-card.label.add-datasource" | translate }}.</a
            ></span
          >
        </ng-template>
      </ng-container>

      <sui-button
        *ngIf="showFilters$ | async"
        variant="secondary"
        size="xsm"
        [leadingIcon]="['fas', 'filter']"
        [iconOnly]="true"
        [ariaLabel]="'widget-card.label.add-filter' | translate"
        [suiTooltip]="'widget-card.label.add-filter' | translate"
        (click)="configureFilters()"
      ></sui-button>

      <sui-button
        *ngIf="showPivots$ | async"
        variant="secondary"
        size="xsm"
        [leadingIcon]="['fas', 'layer-group']"
        [iconOnly]="true"
        [ariaLabel]="'widget-card.label.add-pivot' | translate"
        [suiTooltip]="'widget-card.label.add-pivot' | translate"
        (click)="configurePivots()"
      ></sui-button>

      <span class="dimensions" *ngIf="showDimensions$ | async">
        {{ "widget-card.label.dimensions" | translate }}:
      </span>

      <ng-container
        *ngIf="
          (showFilters$ | async) && (hasFilters$ | async) && isFiltersSelected
        "
      >
        <span
          class="dimension filter"
          *ngFor="let dimension of widget.dimensions_filter"
          (click)="editFilter(dimension)"
        >
          <fa-icon [icon]="dimension.icon"></fa-icon> {{ dimension.title }}
          <a (click)="removeFilter(dimension, $event)" class="remove-filter">
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
          </a>
        </span>
      </ng-container>

      <ng-container
        *ngIf="
          (showPivots$ | async) && (hasPivots$ | async) && isPivotsSelected
        "
      >
        <span
          class="dimension pivot"
          (click)="editFilter(dimension)"
          *ngFor="let dimension of widget.dimensions_pivot"
        >
          <fa-icon [icon]="dimension.icon"></fa-icon> {{ dimension.title }}
          <a (click)="removePivot(dimension, $event)" class="remove-filter">
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
          </a>
        </span>
      </ng-container>
      <span
        class="widget-period"
        *ngIf="hasCustomPeriod && periodTimeStart && periodTimeEnd"
      >
        <fa-icon [icon]="['fas', 'calendar']"></fa-icon>
        <span class="period-dates">
          {{ periodTimeStart * 1000 | date: "dd MMM yyyy, HH:mm" }} –
          {{ periodTimeEnd * 1000 | date: "dd MMM yyyy, HH:mm" }}
        </span>
      </span>
      <span
        class="widget-override-output-settings"
        *ngIf="hasOverrideOutputSettings"
        [suiTooltip]="
          'widget-card.tooltip.this-widget-uses-custom-output-settings'
            | translate
        "
      >
        <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
        {{ "widget-card.label.custom-output-settings" | translate }}
      </span>
    </div>
  </div>

  <div
    class="widget-content"
    #widgetContent
    appInView
    (inView)="handleVisibilityChange($event)"
  >
    <app-loading
      *ngIf="
        widget.loading &&
        widgetTypeId != WidgetType.WIDGET_TYPE_PLACEHOLDER &&
        widgetTypeId != WidgetType.WIDGET_TYPE_SECTION_BREAK &&
        showLoading
      "
    ></app-loading>
    <span
      class="plus-sign"
      *ngIf="widgetTypeId == WidgetType.WIDGET_TYPE_PLACEHOLDER"
    >
      <fa-icon [icon]="['fas', 'plus']"></fa-icon>
    </span>

    @if (!widget.loading || !showLoading) {
      @if (!hasResults && !shouldHideMessage(widgetTypeId)) {
        <app-no-results [message]="noContentMsg"></app-no-results>
      } @else {
        <highcharts-chart
          *ngIf="isHighchart && chartOptions.length > 0"
          [Highcharts]="Highcharts"
          [oneToOne]="true"
          [constructorType]="chartConstructor"
          [options]="chartOptions[currentChartIndex]"
          [callbackFunction]="chartCallback"
          style="width: 100%; height: 100%; display: block; min-height: 200px"
        >
        </highcharts-chart>

        <div
          *ngIf="widgetTypeId === WidgetType.WIDGET_TYPE_TABLE"
          class="table-responsive"
          style="width: 100%; height: 100%; overflow: auto"
        >
          <table
            class="table table-hover"
            style="margin-block-end: 0px"
            *ngIf="
              tableData && tableData[0] && tableData[0].data;
              else noDataTemplate
            "
          >
            <tr *ngFor="let record of tableData[0].data">
              <td>
                <a>{{ record.name }}</a>
              </td>
              <td style="text-align: right">
                <b>{{ record.y }}</b>
              </td>
            </tr>
          </table>
          <ng-template #noDataTemplate>
            <table class="table table-hover" style="margin-block-end: 0px">
              <tr>
                <td colspan="2">
                  {{ "widget-card.label.no-data-table-avaialble" | translate }}
                </td>
              </tr>
            </table>
          </ng-template>
        </div>
        <div
          class="card-container posts"
          *ngIf="widgetTypeId === WidgetType.WIDGET_TYPE_POST_LIST"
        >
          <app-post-card
            *ngFor="let post of posts"
            [post]="post"
            [user]="user"
            [feedId]="widget?.datasources[0]?.id"
            [objectTypeId]="widget?.datasources[0]?.object_type_id"
            [backgroundColor]="widget.settings?.post_background_color"
            [selectable]="false"
            [removable]="false"
            [allowRelatedPosts]="true"
            [viewConfig]="postCardViewConfig"
          ></app-post-card>
        </div>
        <div
          class="section-break"
          *ngIf="widgetTypeId === WidgetType.WIDGET_TYPE_SECTION_BREAK"
        >
          <span class="title"></span>
          <span
            *ngIf="widget.settings.section_break_page_break_before"
            class="title"
          >
            {{ "widget-card.title.page-break-before" | translate }}
          </span>
          <span
            *ngIf="!widget.settings.section_break_page_break_before"
            class="title"
          ></span>
        </div>
      }
    }
  </div>

  <div
    *ngIf="!widget.loading && widgetItems?.length > 1"
    class="chart-tabs-holder"
  >
    <div
      *ngFor="let item of widgetItems; let i = index"
      (click)="changeIndex(i)"
      class="tabs"
    >
      <div class="tab" [class.active]="i === currentChartIndex">
        {{ item.title }}
      </div>
    </div>
  </div>
</div>
